import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { redmondConfig } from "./data";

export default function RedmondPage() {
  return <OregonCityPageTemplate config={redmondConfig} />;
}